import styled from 'styled-components';

export const Profiles = styled.div`
  /* margin: 22px 16px 0; */
  margin-bottom: 22px;
`;

export const ProfileItem = styled.div`
  display: flex;
  align-items: center;
`;

export const Photo = styled.img`
  border-radius: 50%;
  height: 72px;
  width: 72px;
`;

export const WorkerInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Right = styled.div`
  margin-left: 16px;
`;

export const Name = styled.h3`
  margin-bottom: 3px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
`;

export const Abb = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  color: #97979b;
`;
export const Work = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 1.2;
  color: #55555c;
`;

export const Left = styled.div`
  p {
    font-weight: 400;
    font-size: 15px;
    line-height: 1.2;
    color: #55555c;
  }
`;
